module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAGBAMAAAAmmzNnAAAAAXNSR0IArs4c6QAAACRQTFRFAAAAVVVVYGB/VWB1WmB1V2JyV2BzWF9yV19yV2ByV19yV19yZn126QAAAAt0Uk5TAAMIGCUvUrHH4PHi7zBVAAAAMElEQVQI12MwXxHAwMCAIKt3TwSyEOTq3VuALATZvXsRkIUgI3clAFkIktEJyECQAGx8GguC9TdFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/no.png
// module id = 8vHv
// module chunks = 0